(function () {
  'use strict';

  angular
    .module('app.product-kit', [])

    .component('kitComponents', {
      require: {
        productCtrl: '^^productDetail'
      },
      bindings: {
        idKit: '@',
        idGroup: '@',
        device: '<'
      },
      /* @ngInject */
      templateUrl: ["$sce", function ($sce) {
        return $sce.trustAsResourceUrl('/Template/Product/KitComponents');
      }],
      controllerAs: 'kitCtrl',
      /* @ngInject */
      controller: ["$rootScope", "$scope", "$element", "$timeout", "productService", "HttpService", "WindowEventsService", function ($rootScope, $scope, $element, $timeout, productService, HttpService, WindowEventsService) {

        var ctrl = this;

        ctrl.attributes = {};

        ctrl.$onInit = function () {

          getComponents(ctrl.idKit);

          setTimeout(function () {
            WindowEventsService.listen(true, 'resize', resize, 500);
          });

          $scope.$on('$destroy', function () {
            WindowEventsService.listen(false, 'resize', resize);
          });

          resize();

          // Functions

          function resize() {
            $timeout(function () {
              resizeKits();
            });
          }

        };

        ctrl.changeAttribute = function (uniqueId) {
          var current = _.find(ctrl.Components, function (component) {
            return component.uniqueId === uniqueId;
          });

          var url = current.URL || current.Product.URL;
          _.each(ctrl.attributes[uniqueId], function (attr) {
            url = attr === '' ? url : url + '/' + attr;
          });

          if (_.includes(url, '?')) {
            url += '&checkVisibility=false';
          } else {
            url += '?checkVisibility=false';
          }

          current.showLoader = true;
          HttpService.get({
            url: url,
            cache: true
          })
            .then(function (response) {
              current.Product = response;
              current.isPrimary = !current.Product.IsGroupingProduct || (current.Product.IsGroupingProduct && current.Product.SelectedProduct !== null);
              current.currentModel = current.Product.SelectedProduct || current.Product;
              updateComponent(current);
              current.showLoader = false;
            })
            .catch(function (error) {
              console.error(error);
            });
        };

        ctrl.selectCustomComponent = function (component, element) {
          if (element && !element.Product.AllowAddToCart) return;
          component.Product = !element ? null : element.Product;
          component.currentModel = !element ? null : component.Product;
          component.AdditionalCost = !element ? null : element.AdditionalCost;
          updateComponent(component);
        };

        // Functions

        function getComponents(id) {
          ctrl.showLoader = true;
          HttpService.post({
            url: '/Product/GetComponents',
            data: id
          })
            .then(function (response) {
              if (response.status === 'OK') {
                ctrl.Components = [];
                var customGroups = {},
                  i = 0;
                _.each(response.results, function (component) {
                  if (!component.Type) { // Pack standard
                    var qty = component.KitQuantity;
                    component = {
                      Product: component,
                      Quantity: qty
                    };
                  } else { // Pack Personnalisable
                    if (!customGroups[component.Id]) {
                      customGroups[component.Id] = true;
                      component.groupTitle = component.Designation;
                      component.groupFirstElement = true;
                    }
                    if ((component.Type === 901 || component.Type === 903) && !component.Product) return; // Fallback personnalisation sans article
                    if (component.Type === 902) { // Liste d'articles
                      var productDefault = _.find(component.Elements, function (element) {
                        return element.Product.IDProduct === component.IDProductDefault && element.Product.AllowAddToCart;
                      });
                      if (component.groupFirstElement && productDefault) { // Si produit par défaut
                        ctrl.selectCustomComponent(component, productDefault);
                      }
                    }
                  }

                  if (!((component.Type === 901 || component.Type === 903) && !component.Product)) { // Si le composant a bien un article on l'ajoute à la liste du controlleur
                    component.uniqueId = component.Product ? component.Product.IDProduct + '_' + i : component.Id + '_' + i;
                    ctrl.attributes[component.uniqueId] = [];
                    initComponent(component);
                    ctrl.Components.push(component);
                  }

                  i++;
                });

                refreshSelects();

                $timeout(resizeKits);

                $rootScope.$broadcast('updateProduct');
                $rootScope.$broadcast('updateComment', productService.getProduct()[ctrl.idGroup].Comment);
              }
              ctrl.showLoader = false;
            })
            .catch(function (error) {
              console.error(error);
            });
        }

        function resizeKits() {
          var $elem = $('.product-kit'),
            $divs = $elem.find('.row').find('.grid');

          if (!$divs.length) {
            return;
          }

          var col = $divs.eq(0).attr('class').split('col-' + ctrl.device.size + '-')[1];

          if (!col) {
            return;
          }

          var nb = 12 / col.split(' ')[0];
          if (nb === 1) return;

          var i, j, targ, len = $divs.find('.product-item').length;
          for (i = 0; i < len; i += nb) {
            targ = $divs.slice(i, i + nb).find('.content');
            var n = targ.eq(0).children().length;
            for (j = 0; j < n; j++) {
              targ.find('.' + $(targ.eq(0).children().eq(j)).attr('class').split(' ')[0]).equalHeights();
            }
          }

        }

        function initComponent(component) {
          if (component.Type === 901 || component.Type === 902) { // Pack personnalisable - Article simple ou liste d'articles
            component.isPrimary = true;
            component.currentModel = component.Product;
          } else if (component.Type === 903) { // Pack personnalisable - Article décliné
            component.isPrimary = !component.Product ? false : !component.Product.IsGroupingProduct || (component.Product.IsGroupingProduct && component.Product.SelectedProduct !== null);
            component.currentModel = !component.Product ? null : component.Product.SelectedProduct || component.Product;
            component.Attributes = !component.Product ? null : component.Product.Attributes;
            if (component.isPrimary) {
              var i = 0;
              _.each(component.Attributes, function (attr) {
                ctrl.attributes[component.uniqueId][i] = _.find(attr.Values, { 'Selected': true }).Key;
                i++;
              });
            }
          } else if (!component.Type) { // Pack standard -Article simple ou décliné
            component.isPrimary = !component.Product.IsGroupingProduct || (component.Product.IsGroupingProduct && component.Product.SelectedProduct !== null);
            component.currentModel = component.Product.SelectedProduct || component.Product;
          }

          productService.setKitElement(ctrl.idGroup, component);
        }

        function updateComponent(component) {
          productService.setKitElement(ctrl.idGroup, component);
          $rootScope.$broadcast('updateProduct');
          $rootScope.$broadcast('updateComment', productService.getProduct()[ctrl.idGroup].Comment);
        }

        function refreshSelects() {
          setTimeout(function () {
            $element.find('select.refresh').each(function (index, el) {
              $(el).selectpicker('refresh');
            });
          });
        }
      }]
    });

})();
